<template>
  <v-col cols="12">
    <base-card>
      <v-card-title>Búsqueda de Eventos</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="3"
          >
            <v-text-field
              v-model="filters.trace_id"
              label="Trace ID"
              placeholder="UUID del evento"
              prepend-inner-icon="mdi-identifier"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3"
          >
            <v-text-field
              v-model="filters.access_key"
              label="Clave de Acceso"
              placeholder="49 dígitos"
              prepend-inner-icon="mdi-key"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            sm="4"
            md="2"
          >
            <v-select
              v-model="filters.final_status"
              :items="statuses"
              item-text="text"
              item-value="value"
              label="Estado Final"
              prepend-inner-icon="mdi-order-bool-descending-variant"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            sm="4"
            md="2"
          >
            <v-select
              v-model="filters.source_process"
              :items="processes"
              item-text="text"
              item-value="value"
              label="Proceso Origen"
              prepend-inner-icon="mdi-cog"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            sm="4"
            md="2"
          >
            <v-select
              v-model="filters.has_errors"
              :items="errorOptions"
              item-text="text"
              item-value="value"
              label="Errores"
              prepend-inner-icon="mdi-alert-circle"
              clearable
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="4"
          >
            <v-select
              v-model="filters.company_id"
              :items="filteredClients"
              item-text="text"
              item-value="IdCompania"
              label="Selecciona una compañía"
              prepend-inner-icon="mdi-sitemap"
              clearable
            >
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-text-field
                        v-model="companySearch"
                        placeholder="Buscar"
                        prepend-inner-icon="mdi-magnify"
                        hide-details
                        dense
                      />
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="12"
            sm="4"
          >
            <v-dialog
              ref="dialog"
              v-model="modalDate"
              :return-value.sync="filters.dates"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filters.dates"
                  label="Rango de fechas"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="filters.dates"
                range
              >
                <v-spacer />
                <v-btn
                  text
                  style="background-color:rgb(204 33 40);color:white !important"
                  @click="modalDate = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  style="background-color:rgb(204 33 40);color:white !important"
                  @click="$refs.dialog.save(filters.dates)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col
            cols="12"
            sm="2"
          >
            <v-text-field
              v-model="filters.prefijo"
              label="Prefijo"
              placeholder="001-001"
              prepend-inner-icon="mdi-file"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            sm="2"
          >
            <v-text-field
              v-model="filters.consecutivo"
              label="Consecutivo"
              placeholder="000000001"
              prepend-inner-icon="mdi-note-multiple"
              clearable
            />
          </v-col>
        </v-row>
        <v-row justify="end">
          <v-col
            cols="12"
            sm="4"
            class="text-right"
          >
            <v-btn
              class="ma-2"
              style="background-color:rgb(204 33 40);color:white !important"
              @click="search"
            >
              Buscar
            </v-btn>
            <v-btn
              class="ma-2"
              color="GRAY"
              @click="clearFilters"
            >
              Nueva Búsqueda
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          v-if="loadingSearch"
          class="fill-height"
          align-content="center"
          justify="center"
        >
          <v-col cols="6">
            <v-col
              class="text-subtitle-1 text-center"
              cols="12"
            >
              Consultando Eventos
            </v-col>
            <v-progress-linear
              color="red darken-4"
              indeterminate
              rounded
              height="6"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-alert
              v-if="notFoundEvents"
              text
              type="info"
            >
              No se encontraron <strong>eventos</strong> para los filtros aplicados.
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
    </base-card>
  </v-col>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { environment } from '@/data/environment/'
import { wideEventsStatuses, wideEventsProcesses } from '@/data/wideEventsStatuses'

export default {
  data () {
    return {
      hasSearched: false,
      modalDate: false,
      companySearch: '',
      detailClients: [],
      statuses: wideEventsStatuses,
      processes: wideEventsProcesses,
      errorOptions: [
        { text: 'Solo con errores', value: true },
        { text: 'Solo exitosos', value: false },
      ],
      filters: {
        trace_id: '',
        company_id: null,
        prefijo: '',
        consecutivo: '',
        access_key: '',
        has_errors: '',
        source_process: '',
        final_status: '',
        dates: [],
      },
    }
  },
  computed: {
    ...mapState('wideEvents', ['loadingSearch', 'searchResults']),
    notFoundEvents () {
      return this.hasSearched && !this.loadingSearch && this.searchResults && this.searchResults.length === 0
    },
    filteredClients () {
      const query = (this.companySearch || '').toLowerCase()
      return this.detailClients.filter(c =>
        c.text.toLowerCase().includes(query),
      )
    },
  },
  created () {
    this.obtenerCompanias()

    
    const query = this.$route.query
    if (query.company_id) this.filters.company_id = parseInt(query.company_id)
    if (query.has_errors) this.filters.has_errors = query.has_errors === 'true'
    if (query.final_status) this.filters.final_status = query.final_status

    // Solo buscar automáticamente si viene con parámetros
    if (query.company_id || query.has_errors || query.final_status) {
      this.search()
    }
  },
  methods: {
    async obtenerCompanias () {
      try {
        const response = await axios.get(environment.HIOPOSWEBSERVICES + '/getClientsForXML')
        const companies = response.data.Mensaje
        this.detailClients = companies.map(c => ({
          text: ' [ ' + c.id + ' ] ' + c.name,
          IdCompania: c.id,
        }))
      } catch (error) {
        console.error('Error al obtener compañías:', error)
      }
    },
    search () {
      this.hasSearched = true
      const params = { ...this.filters }
      if (params.dates && params.dates.length > 0) {
        params.date_from = params.dates[0]
        params.date_to = params.dates[1] || params.dates[0]
      }
      delete params.dates
      this.$store.dispatch('wideEvents/searchEvents', params)
    },
    clearFilters () {
      this.hasSearched = false
      this.filters = {
        trace_id: '',
        company_id: null,
        prefijo: '',
        consecutivo: '',
        access_key: '',
        has_errors: '',
        source_process: '',
        final_status: '',
        dates: [],
      }
    },
  },
}
</script>
